import { useEffect, useRef } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

export const LAST_PORTAL_PAGE_KEY = 'gov_last_portal_page'
export const WORKSPACE_ACCESS_ORIGIN_COOKIE = 'gov_workspace_access_origin'
export const DIRECT_ACCESS_ORIGIN = 'Acesso direto via URL'
const WORKSPACE_FORMULARIOS_PATH = '/workspace/formularios'

function currentPortalUrl(pathname: string, search: string): string {
  return `${window.location.origin}${pathname}${search}`
}

function saveWorkspaceAccessOrigin(originUrl: string) {
  document.cookie = `${WORKSPACE_ACCESS_ORIGIN_COOKIE}=${originUrl};path=/`
}

function PortalOriginTracker({ history }: RouteComponentProps): null {
  const currentUrlRef = useRef(
    currentPortalUrl(history.location.pathname, history.location.search),
  )
  const currentPathnameRef = useRef(history.location.pathname)

  useEffect(() => {
    if (currentPathnameRef.current.startsWith(WORKSPACE_FORMULARIOS_PATH)) {
      const lastPortalPage = sessionStorage.getItem(LAST_PORTAL_PAGE_KEY)
      saveWorkspaceAccessOrigin(lastPortalPage ?? DIRECT_ACCESS_ORIGIN)
    }

    const unlisten = history.listen((location) => {
      const previousUrl = currentUrlRef.current
      const wasInsideWorkspaceFormularios =
        currentPathnameRef.current.startsWith(WORKSPACE_FORMULARIOS_PATH)

      sessionStorage.setItem(LAST_PORTAL_PAGE_KEY, previousUrl)

      if (
        location.pathname.startsWith(WORKSPACE_FORMULARIOS_PATH) &&
        !wasInsideWorkspaceFormularios
      ) {
        saveWorkspaceAccessOrigin(previousUrl)
      }

      currentUrlRef.current = currentPortalUrl(
        location.pathname,
        location.search,
      )
      currentPathnameRef.current = location.pathname
    })
    return () => unlisten()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default withRouter(PortalOriginTracker)
